import { render } from "./Collection_Record_Edit.vue?vue&type=template&id=3ed3506a"
import script from "./Collection_Record_Edit.vue?vue&type=script&lang=js"
export * from "./Collection_Record_Edit.vue?vue&type=script&lang=js"

import "./Collection_Record_Edit.vue?vue&type=style&index=0&id=3ed3506a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__